module.exports = __webpack_public_path__ + "img/a.41539845.svg";